import React, { useEffect, useState, useRef } from "react";
import Client from "@/assets/dashboard/Client.png";

function ClientApercus() {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <img
        src={Client}
        alt="pages"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

export default ClientApercus;
